import { useQuery } from '@tanstack/react-query';
import { walletApi } from '@/api/wallet-api';

const WALLET_KEY = 'wallet';

export function useWalletBalance() {
  return useQuery({
    queryKey: [WALLET_KEY, 'balance'],
    queryFn: () => walletApi.getBalance(),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    retry: 2,
  });
}

export function useAvailableBalance() {
  return useQuery({
    queryKey: [WALLET_KEY, 'available'],
    queryFn: () => walletApi.getAvailableBalance(),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    retry: 2,
  });
}

export function usePendingBalance() {
  return useQuery({
    queryKey: [WALLET_KEY, 'pending'],
    queryFn: () => walletApi.getPendingBalance(),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    retry: 2,
  });
}
